import { StarIcon } from "@phosphor-icons/react";
import { useTranslations } from "use-intl";

import {
  SearchResultButton,
  SearchResultList,
} from "@/components/SearchResultList/SearchResultList";
import type { Airport, City } from "@/types/types";

type Props<T> = {
  topLocations: T[];
  onClick: (location: T) => void;
  getPrimaryText?: (location: T) => React.ReactNode;
  showCode?: boolean;
};

export function TopLocationList<T extends Airport | City>({
  onClick,
  topLocations,
  getPrimaryText = (loc) => loc.name,
  showCode,
}: Props<T>) {
  const t = useTranslations();

  return (
    <SearchResultList
      heading={t("topLocations")}
      data={topLocations}
      getItemKey={(location) => location.id}
      renderItem={(location) => {
        return (
          <SearchResultButton
            key={location.id}
            icon={StarIcon}
            primaryText={getPrimaryText(location)}
            secondaryText={location.countryName}
            code={showCode ? location.code : undefined}
            onClick={() => onClick(location)}
          />
        );
      }}
    />
  );
}
